import { useEffect, useRef, useState } from "react";
import { hasAuthParams, useAuth } from "react-oidc-context";
import { createBrowserRouter } from "react-router-dom";
import Generator from "../components/Generator/Generator";
import Home from "../components/Home/Home";
import Presenter from "../components/Presenter/Presenter";
import Segmenter from "../components/Segmenter/Segmenter";
import CampaignBrief from "../components/CampaignBrief/CampaignBrief";
import { LoadingPage } from "../pages/loading_page/LoadingPage";
import DataWorkbench from "../components/DataWorkbench/DataWorkbench";
import Operations from "../components/Operations/Operations";
import { cognitoAuthConfig } from "../cognitoAuthConfig";

export const ProtectedRoute = ({ element }) => {
  const { isLoading, isAuthenticated, user, error, activeNavigator, signinRedirect } = useAuth();
  const redirectStarted = useRef(false);
  const [redirectError, setRedirectError] = useState(null);
  const hasSession = isAuthenticated && Boolean(user?.access_token);
  const configurationError = !cognitoAuthConfig.metadataSeed.token_endpoint
    ? "REACT_APP_OAUTH_TOKEN_URL is missing. Set it in .env and restart the development server, or rebuild the deployed app."
    : null;

  useEffect(() => {
    if (
      configurationError || hasSession || isLoading || error || redirectError || activeNavigator ||
      hasAuthParams() || redirectStarted.current
    ) {
      return;
    }

    redirectStarted.current = true;
    signinRedirect().catch(setRedirectError);
  }, [configurationError, hasSession, isLoading, error, redirectError, activeNavigator, signinRedirect]);

  const authError = configurationError || error || redirectError;
  if (authError) {
    return (
      <div role="alert">
        <h2>Sign-in failed</h2>
        <p>{typeof authError === "string" ? authError : authError.message || "Unable to complete sign-in."}</p>
      </div>
    );
  }

  if (isLoading || activeNavigator || !hasSession) {
    return <LoadingPage />;
  }

  return element;
};

export const app_router = createBrowserRouter([
  {
    path: "/",
    element: <ProtectedRoute element={<Home />} />,
    children: [
      {
        index: true,
        element: <Segmenter />,
      },
      {
        path: "aggregator",
        element: <DataWorkbench />,
      },
      {
        path: "generator",
        element: <Generator />,
      },
      {
        path: "presenter",
        element: <Presenter />,
      },
      {
        path: "operations",
        element: <Operations />,
      },
      {
        path: "campaign-brief",
        element: <CampaignBrief />,
      },
    ],
  },
]);
